import { JewelryType, JewelryCondition, JewelryPurchaseCondition } from './constants';
import typeHints from './typeHints';

const attributes = {

  jewelry_type: {
    friendly: 'Type',
    validations: {
      type: 'enum',
      enumType: JewelryType,
    },
  },

  jewelry_maker: {
    friendly: 'Maker',
    validations: {
      maxLength: 255,
    },
  },

  jewelry_designer: {
    friendly: 'Designer',
    validations: {
      maxLength: 255,
    },
  },

  jewelry_date_created: {
    friendly: 'Date Created',
    validations: {
      type: 'date',
    },
    typeHint: typeHints.Date,
  },

  jewelry_metal: {
    friendly: 'Metal',
    validations: {
      maxLength: 255,
    },
  },

  jewelry_gemstones: {
    friendly: 'Gemstones',
    validations: {
      maxLength: 255,
    },
  },

  jewelry_marks: {
    friendly: 'Marks',
    validations: {
      maxLength: 255,
    },
  },

  jewelry_dimensions: {
    friendly: 'Dimensions',
    validations: {
      maxLength: 255,
    },
  },

  jewelry_weight: {
    friendly: 'Weight',
    validations: {
      maxLength: 255,
    },
  },

  jewelry_country_of_origin: {
    friendly: 'Country',
    validations: {
      maxLength: 255,
    },
  },

  jewelry_accessories: {
    friendly: 'Accessories',
    validations: {
      maxLength: 255,
    },
  },

  jewelry_condition: {
    friendly: 'Condition',
    validations: {
      type: 'enum',
      enumType: JewelryCondition,
    },
  },

  jewelry_purchase_condition: {
    friendly: 'Purchase Condition',
    validations: {
      type: 'enum',
      enumType: JewelryPurchaseCondition,
    },
  },


};

export default attributes;

export const JewelryDefaultSplitAttribute = 'jewelry_type';

export const JewelryItemSearchAttributes = [];

export const JewelryOverviewAttributes = ['title', 'jewelry_type', 'jewelry_maker', 'jewelry_designer', 'jewelry_date_created', 'jewelry_country_of_origin',
  'jewelry_condition', 'rarity', 'market_value', 'quantity', 'inventory_no', 'tags'];

export const JewelrySpecificationAttributes = ['jewelry_metal', 'jewelry_gemstones', 'jewelry_marks', 'jewelry_dimensions', 'jewelry_weight', 'jewelry_accessories'];

export const JewelryPurchaseAttributes = ['purchase_date', 'purchase_price', 'jewelry_purchase_condition', 'purchase_contact', 'purchase_notes'];

export const JewelryDetailAttributes = [];

export const JewelryRequiredAttributes = [];

export const JewelryDisplayAttributes = ['jewelry_type', 'jewelry_maker', 'jewelry_designer', 'jewelry_metal', 'jewelry_gemstones', 'tags'];

export const JewelrySliderGalleryAttributes = {
  titleKey: 'jewelry_type',
  subtitleKey: 'jewelry_maker',
};



// WEBPACK FOOTER //
// ./src/config/jewelryDataAttributes.js